import { usePageTitle } from "@/hooks/usePageTitle";

export function ContactsPage() {
  usePageTitle("Kontaktai");

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="mb-8 text-3xl font-bold text-gray-900">Kontaktai</h1>

      <div className="space-y-8">
        <div className="rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900">
            Susisiekite su mumis
          </h2>
          <p className="mt-2 text-gray-600">
            Turite klausimų, pasiūlymų ar pastebėjote problemą? Mielai
            padėsime!
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          <div className="rounded-lg border border-gray-200 p-6">
            <h3 className="font-semibold text-gray-900">El. paštas</h3>
            <a
              href="mailto:info@boardo.lt"
              className="mt-2 block text-primary-800 hover:text-primary-700"
            >
              info@boardo.lt
            </a>
          </div>

          <div className="rounded-lg border border-gray-200 p-6">
            <h3 className="font-semibold text-gray-900">Socialiniai tinklai</h3>
            <p className="mt-2 text-gray-600">Sekite mus Facebook puslapyje</p>
          </div>
        </div>

        <div className="rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900">
            Atsakymo laikas
          </h2>
          <p className="mt-2 text-gray-600">
            Stengiamės atsakyti į visus laiškus per 1–2 darbo dienas.
          </p>
        </div>
      </div>
    </div>
  );
}
